import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'

// import { navigationOptionsDefault } from '../config/navigation'

import NewsOverviewScreen from '../screens/news/NewsOverviewScreen'
import NewsDetailScreen from '../screens/news/NewsDetailScreen'
import { commonScreenOptions } from '../config/navigation'

const Stack = createStackNavigator()
const NewsNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="News"
      screenOptions={{ ...commonScreenOptions }}
    >
      <Stack.Screen
        name="News"
        component={NewsOverviewScreen}
        options={{ headerShown: false, title: 'Neues' }}
      />
      <Stack.Screen
        name="NewsDetail"
        component={NewsDetailScreen}
        options={(/* { route } */) => ({ title: '' })}
      />
    </Stack.Navigator>
  )
}

export default NewsNavigator
